import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import EcologicalTabs from "@/components/EcologicalTabs";
import ModuleTabs from "@/components/ModuleTabs";
import { UserChangeTabs } from "@/hooks";

import dataJson from "@/../public/data.json";

import "./index.less";
const prefix = "equipmentDevelopment";

function EquipmentDevelopment() {
  const { equipmentDevelopment } = dataJson;

  const [tabActive, setTabActive] = useState<string | null>("");
  const [key, setKey] = useState<string | null>("");
  const [params, setParams] = useSearchParams();

  const { current, tabsChange } = UserChangeTabs(prefix, equipmentDevelopment, key);

  useEffect(() => {
    const key = params.get("key");
    const tabKey = params.get("tabKey");
    key && setKey(key);
    tabKey && setTabActive(tabKey);
  }, []);

  console.log('equipmentDevelopment.list =>', equipmentDevelopment.list)

  return (
    <div className={prefix}>
      <div className={`${prefix}-banner`} style={{ backgroundImage: `url(${equipmentDevelopment.banner_bg_img})` }}>
        <div className={`${prefix}-title`}>{equipmentDevelopment.title}</div>
        <div className={`${prefix}-describe`}>
          <div>{equipmentDevelopment.describe}</div>
        </div>
      </div>
      <EcologicalTabs current={current} list={equipmentDevelopment.list} onChange={tabsChange} />
      <div className={`${prefix}-content`}>
        {equipmentDevelopment.list.map((item: any) => {
          return (
            <div key={item.key} className={`${prefix}-module`} id={`${prefix}-module-${item.key}`}>
              <div className={`${prefix}-module-title`}>{item.title}</div>
              <div className={`${prefix}-module-tabs`}>
                <ModuleTabs list={item.list} tabActive={tabActive} isShowImg= { item.key === '1'} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default EquipmentDevelopment;
